<template>
	<div class="basket-price-block flex" :class="blockClass">
		<citrus-product-basket-price
			v-if="(price.price > 0)"
			:base-price="price.full"
			:discount-price="price.price"
			:has-sku="hasSku"
		></citrus-product-basket-price>
		<div class="item_btn_wr">
			<citrus-product-basket-button
				:product-id="productId"
				:product-name="productName"
				:price="price"
				:detail-url="detailUrl"
				:basket-url="basketUrl"
				:has-sku="hasSku"
				:show-mobile="showMobile"
				:storage-type="storageType"
				:bind-global-basket="true"
				:custom-text="customText"
			></citrus-product-basket-button>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'CitrusProductBasketButtonPrice',
	};
</script>